import React from 'react';

import type { Account } from '../../generated-types';
import LoanListItem from './LoanListItem';

import './LoanList.scss';

interface Props {
    loans?: Account[];
    url?: string;
}

const LoanList: React.FC<Props> = ({ loans, url }) => {
    if (!url) return null;
    return <>{loans?.map((loan) => <LoanListItem key={loan.accountId.value} loan={loan} url={url} />)}</>;
};

export default LoanList;
